require("intersection-observer");

import simpleParallax from "simple-parallax-js";
import "./utils/easing.js";
import "./utils/device.js";
import "./utils/customSelect.js";
import "./utils/jquery.swipebox.min.js";
import "./utils/jq.js";
import "./utils/form.js";
import "./components/navigation.js";
import LazyLoad from "vanilla-lazyload";
import SmoothScroll from "smoothscroll-for-websites";

const lazyLoadOptions = {};
const pageLazyLoad = new LazyLoad(lazyLoadOptions);

SmoothScroll({
  // Scrolling Core
  animationTime: 600, // [ms]
  stepSize: 100, // [px]

  // Acceleration
  accelerationDelta: 50, // 50
  accelerationMax: 4, // 3

  // Keyboard Settings
  keyboardSupport: true, // option
  arrowScroll: 120, // [px]

  // Pulse (less tweakable)
  // ratio of "tail" to "acceleration"
  pulseAlgorithm: true,
  pulseScale: 4,
  pulseNormalize: 1,

  // Other
  touchpadSupport: false, // ignore touchpad by default
  fixedBackground: true,
  excluded: "",
});

const plxImages = document.querySelectorAll(".parallax-bg");
new simpleParallax(plxImages, {
  delay: 0,
});

var rlImages = document.querySelectorAll(".parallax-right-left");
new simpleParallax(rlImages, {
  delay: 0,
  orientation: "left",
  // scale: 1.6,
  overflow: true,
});

function debounce(func, wait, immediate) {
  var timeout;
  return function() {
    var context = this,
      args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

var checkScroll = debounce(function scrolled() {
  const body = document.querySelector("body");

  var scrolled = false;
  if (scrollY > window.innerHeight) {
    body.classList.add("scrolled");
    var scrolled = true;
  }
  if (scrolled) {
    window.removeEventListener("scroll", checkScroll, false);
  }
}, 2);

window.addEventListener("scroll", checkScroll, false);

var body = document.querySelector("body");

if (body) {
  window.onload = function() {
    body.classList.add("ready");
    setTimeout(function() {
      document.querySelector("#loading").remove();
    }, 390);
  };
}

const rows = document.querySelectorAll(".animate-row");
var elementInViewport = debounce(function() {
  rows.forEach((i) => {
    var bounding = i.getBoundingClientRect();
    var myElementHeight = i.offsetHeight;
    var myElementWidth = i.offsetWidth;
    if (
      bounding.top >= -myElementHeight &&
      bounding.left >= -myElementWidth &&
      bounding.right <=
        (window.innerWidth || document.documentElement.clientWidth) +
          myElementWidth &&
      bounding.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) +
          myElementHeight
    ) {
      i.classList.add("invp");
    } else {
      i.classList.remove("invp");
    }
  });
}, 5);
document.addEventListener("DOMContentLoaded", () => {
  window.addEventListener("load", elementInViewport, false);
  window.addEventListener("scroll", elementInViewport, false);
});

const rowsOnce = document.querySelectorAll(".animate-row-once");
var elementInViewportOnce = debounce(function() {
  rowsOnce.forEach((i) => {
    var bounding = i.getBoundingClientRect();
    var myElementHeight = i.offsetHeight;
    var myElementWidth = i.offsetWidth;
    if (
      bounding.top >= -myElementHeight &&
      bounding.left >= -myElementWidth &&
      bounding.right <=
        (window.innerWidth || document.documentElement.clientWidth) +
          myElementWidth &&
      bounding.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) +
          myElementHeight
    ) {
      i.classList.add("invp");
    }
  });
}, 5);
document.addEventListener("DOMContentLoaded", () => {
  window.addEventListener("load", elementInViewportOnce, false);
  window.addEventListener("scroll", elementInViewportOnce, false);
});

let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty("--vh", `${vh}px`);

window.addEventListener("resize", () => {
  // We execute the same script as before
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
});

var $ = require("jquery");
var jQueryBridget = require("jquery-bridget");
var Flickity = require("flickity");
var Flickity = require("flickity-fullscreen");
require("flickity-imagesloaded");
Flickity.setJQuery($);
var Flickity = require("flickity-as-nav-for");
jQueryBridget("flickity", Flickity, $);
var flickityCarousel = function() {
  document.querySelectorAll(".gallery-carousel").forEach((i) => {
    let flkty = new Flickity(i, {
      cellAlign: "left",
      contain: false,
      imagesLoaded: true,
      prevNextButtons: true,
      freeScroll: false,
      pageDots: false,
      fullscreen: true,
      freeScroll: false,
      arrowShape: {
        x0: 10,
        x1: 60,
        y1: 50,
        x2: 60,
        y2: 45,
        x3: 15,
      },
    });

    flkty.on("dragStart", function() {
      document.querySelectorAll("a.gallery-slide").forEach((i) => {
        i.style.pointerEvents = "none";
      });
    });
    flkty.on("dragEnd", function() {
      document.querySelectorAll("a.gallery-slide").forEach((i) => {
        i.style.pointerEvents = "all";
      });
    });
  });
};

var carousel = document.querySelector(".gallery-carousel");
if (carousel) {
  flickityCarousel();
}

var flickityCarousel2 = function() {
  document.querySelectorAll(".gallery-carousel-2").forEach((i) => {
    let flkty = new Flickity(i, {
      cellAlign: "right",
      contain: false,
      imagesLoaded: true,
      prevNextButtons: true,
      freeScroll: false,
      pageDots: false,
      fullscreen: true,
      initialIndex: ".last-slide",
      freeScroll: false,
      arrowShape: {
        x0: 10,
        x1: 60,
        y1: 50,
        x2: 60,
        y2: 45,
        x3: 15,
      },
    });

    flkty.on("dragStart", function() {
      document.querySelectorAll("a.gallery-slide").forEach((i) => {
        i.style.pointerEvents = "none";
      });
    });
    flkty.on("dragEnd", function() {
      document.querySelectorAll("a.gallery-slide").forEach((i) => {
        i.style.pointerEvents = "all";
      });
    });
  });
};

var carousel2 = document.querySelector(".gallery-carousel-2");
if (carousel2) {
  flickityCarousel2();
}
